export default `
## Experience

**Block (formerly Square / Weebly) — Senior Software Engineer - Technical Lead (L6)**

_October 2017 - Present_

* Technical Lead and Engineering DRI for Square Payment Links, owning technical direction for a platform processing $4.2B+ in annualized GPV
* Own architecture and technical direction across multiple squads delivering new platform capabilities while ensuring reliability and evolution of existing checkout infrastructure
* Leading design and development of a scalable AI-assisted website generation platform enabling next-generation seller web experiences while enforcing accessibility and safety guardrails
* Architecting cloud infrastructure and an edge-first delivery strategy using global caching to minimize buyer latency and improve checkout responsiveness
* Partner with Product and Engineering leadership to define multi-quarter technical strategy, roadmap, and execution priorities across the platform
* Mentor engineers through design reviews, technical coaching, and ownership of critical systems

## Open Source Contributions

* Maintainer of read-last-lines (100k+ weekly downloads)
* Author of Home Assistant integration for Moen Smart Water devices
* Contributor across integrations and developer tooling projects

## Teaching & Mentorship

* Guest Faculty, University of Washington iSchool (2023 - Present): Teach Software Architecture and mentor senior Informatics students
* Instructor, Holy Names Academy (2024 - Present): Lead project-based software engineering coursework

---
`;
